/* eslint-disable */
const tourCriteriaNativeNameJsonHydrator = (tourCriteria, tourCriteriaJson, elems = []) => {
    const __tourCriteria = {};
    elems.forEach((item) => {
        const element = tourCriteria.get(item);
        if (element) {
            const fn = element.length ? element.pluck : element.get;
            __tourCriteria[item] = fn.call(element, 'name');
        } else {
            __tourCriteria[item] = [];
        }
    });

    return {...tourCriteriaJson, ...__tourCriteria};
};

export default tourCriteriaNativeNameJsonHydrator;
